/**
 * Root landing (`/`).
 *
 * - With `?token=` — same as the canonical applicant entry: starts the flow
 *   with desktop→phone handoff after consent.
 * - Without a token — friendly product landing (not a red error).
 */
import { useSearchParams } from 'react-router-dom';

import { ChatWidget } from '../flow/ChatWidget';
import { FlowRunner } from '../flow/FlowRunner';
import { EmptySession } from '../ui/EmptySession';

export function HomeScreen() {
  const [params] = useSearchParams();
  const token = params.get('token')?.trim() || null;

  // Keep `/?token=` working in place so the query is never dropped on redirect.
  if (token) {
    return (
      <>
        <FlowRunner token={token} withHandoff />
        <ChatWidget token={token} />
      </>
    );
  }

  return <EmptySession kind="home" />;
}
